import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import useGetCertainEventFromApp from "./useGetCertainEventFromApp";
import { loginHintAtom, LoginMethod } from "recoil/loginHintAtom";

const VALID_METHODS: LoginMethod[] = ["apple", "google", "kakao"];

/**
 * 네이티브가 OneLink 로 전달한 최근 로그인 수단(event: "lastLoginMethod")을 수신해
 * loginHintAtom 에 저장한다. 로그인 화면에서 마운트한다.
 */
export default function useReceiveLoginHint() {
  const setLoginHint = useSetRecoilState(loginHintAtom);
  const message = useGetCertainEventFromApp({ eventName: "lastLoginMethod" });

  useEffect(() => {
    const value = message?.params?.value;
    if (value && VALID_METHODS.includes(value)) {
      setLoginHint(value);
    }
  }, [message, setLoginHint]);
}
